
let url = "https://gwht.zituobiz.com/prod-api";
//let url = "http://192.168.1.108:8989"
//let url = "http://39.101.202.232:8909/prod-api";

module.exports = url;


//////////////////
// WEBPACK FOOTER
// ./js/axiosUrl.js
// module id = 12YN
// module chunks = 1